import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useMediaQuery} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import BoxAtom from '../../../@atoms/to_layout/box/box.atom'
import ContactDetailsWrapperAtom from '../../../@atoms/to_content/contact_details_wrapper/contact_details_wrapper.atom'
import HereMapsComponent from '../../here_maps/here_maps.component'
import TypographyAtom from '../../../@atoms/to_content/typography/typography.atom'
import {RootState} from '../../../store_redux'
import {Visit} from '../../../props_reusable/visit'
import OrdersConfig from '../../../props_reusable/settings'
import {
  showLocationModal,
  showNotifyPrefsModal,
} from '../../../store_redux/reducer/modal.reducer'

const AddressDetails: React.FC<
  Pick<Visit, 'shippingAddressDetail'> & Pick<OrdersConfig, 'setAddress'>
> = function ({shippingAddressDetail, setAddress}) {
  return setAddress !== 'full' ? (
    <>
      <TypographyAtom ahd_type="fData">
        {shippingAddressDetail.contactName}
      </TypographyAtom>
      <TypographyAtom ahd_type="fData">
        {shippingAddressDetail.postcode}
      </TypographyAtom>
    </>
  ) : (
    <>
      <TypographyAtom ahd_type="fData">
        {shippingAddressDetail.contactName}
      </TypographyAtom>
      {shippingAddressDetail.addressLine1 !== '' && (
        <TypographyAtom ahd_type="fData">
          {shippingAddressDetail.addressLine1}
        </TypographyAtom>
      )}
      {shippingAddressDetail.addressLine2 !== '' && (
        <TypographyAtom ahd_type="fData">
          {shippingAddressDetail.addressLine2}
        </TypographyAtom>
      )}
      {shippingAddressDetail.addressLine3 !== '' && (
        <TypographyAtom ahd_type="fData">
          {shippingAddressDetail.addressLine3}
        </TypographyAtom>
      )}
      {shippingAddressDetail.addressLine4 !== '' && (
        <TypographyAtom ahd_type="fData">
          {shippingAddressDetail.addressLine4}
        </TypographyAtom>
      )}
      {shippingAddressDetail.countryDesc !== '' ? (
        <TypographyAtom ahd_type="fData">
          {shippingAddressDetail.countryName},{' '}
          {shippingAddressDetail.countryDesc}
        </TypographyAtom>
      ) : (
        <TypographyAtom ahd_type="fData">
          {shippingAddressDetail.countryName}
        </TypographyAtom>
      )}
      <TypographyAtom ahd_type="fData">
        {shippingAddressDetail.postcode}
      </TypographyAtom>
    </>
  )
}

const ContactDetailsComponent: React.FC<
  Pick<
    Visit,
    | 'visitNumber'
    | 'coordinate'
    | 'shippingAddressDetail'
    | 'notificationDetail'
  >
> = function ({
  visitNumber,
  coordinate,
  shippingAddressDetail,
  notificationDetail,
}) {
  const rootState = useSelector((state: RootState) => state)
  const dispatch = useDispatch()
  const matches = useMediaQuery('(max-width:480px)')
  const {labels, settings} = rootState
  const {addressTitle, notificationsTitle} = labels.myOrders
  const {
    setAddress,
    isNotificationVisible,
    isMapVisible,
    isEditShippingAddressAllowed,
    isEditShippingNotificationsAllowed,
  } = settings

  const openLocationModal = () => {
    // Functionality is not for phase 1
    // So will not work
    const dontCall = true
    const data = {
      visitId: visitNumber,
      addressDetails: shippingAddressDetail,
      coordinate,
    }
    if (!dontCall) dispatch(showLocationModal(data))
  }

  const openNotifyPrefsModal = () => {
    // Functionality is not for phase 1
    // So will not work
    const dontCall = true
    const data = {
      visitId: visitNumber,
      email: notificationDetail.email,
      phone: notificationDetail.mobile,
    }
    if (!dontCall) dispatch(showNotifyPrefsModal(data))
  }

  return (
    <ContactDetailsWrapperAtom>
      {setAddress !== 'none' && (
        <BoxAtom className="address-details-wrapper">
          {matches && isMapVisible && (
            <HereMapsComponent
              ap_latitude={coordinate?.latitude}
              ap_longitude={coordinate?.longitude}
            />
          )}
          <BoxAtom className="label-wrapper">
            <TypographyAtom ahd_type="formLabel">{addressTitle}</TypographyAtom>
            {isEditShippingAddressAllowed && (
              <TypographyAtom ahd_type="navLink" onClick={openLocationModal}>
                {matches ? <EditIcon /> : 'Edit'}
              </TypographyAtom>
            )}
          </BoxAtom>
          <AddressDetails
            shippingAddressDetail={shippingAddressDetail}
            setAddress={setAddress}
          />
        </BoxAtom>
      )}
      {isNotificationVisible && (
        <BoxAtom className="notification-details-wrapper">
          <BoxAtom className="label-wrapper">
            <TypographyAtom ahd_type="formLabel">
              {notificationsTitle}
            </TypographyAtom>
            {isEditShippingNotificationsAllowed && (
              <TypographyAtom ahd_type="navLink" onClick={openNotifyPrefsModal}>
                {matches ? <EditIcon /> : 'Edit'}
              </TypographyAtom>
            )}
          </BoxAtom>
          {!!notificationDetail.email && (
            <TypographyAtom ahd_type="fData">
              {notificationDetail.email}
            </TypographyAtom>
          )}
          {!!notificationDetail.mobile && (
            <TypographyAtom ahd_type="fData">
              {notificationDetail.mobile}
            </TypographyAtom>
          )}
        </BoxAtom>
      )}
    </ContactDetailsWrapperAtom>
  )
}

export default ContactDetailsComponent
